import { omit } from "lodash";
import { INTERNALS } from "../../../common/metadata";
import { normalizeNumericString } from "../../../common/utils";

export const shapeTransectData = (transectData) => {
  return transectData.map(({ id, properties }) => ({
    id: parseInt(id, 10),
    ...omit(properties, [INTERNALS]),
  }));
};

export const buildGeoJsonData = (data) => {
  return {
    type: "FeatureCollection",
    crs: {
      type: "name",
      properties: { name: "EPSG:4326" },
    },
    features: data.map((el) => ({
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: [
          [el.longStart, el.latStart],
          [el.longEnd, el.latEnd],
        ],
      },
      properties: {
        id: el.id,
        dates: normalizeNumericString(el.dates),
        distances: normalizeNumericString(el.distances),
        epr: el.epr,
        firstDate: el.firstDate,
        intercept: el.intercept,
        label: el.label,
        lastDate: el.lastDate,
        latEnd: el.latEnd,
        latStart: el.latStart,
        longEnd: el.longEnd,
        longStart: el.longStart,
        lrr: el.lrr,
        nsm: el.nsm,
        r: el.r,
        rsquared: el.rsquared,
        sce: el.sce,
        slope: el.slope,
      },
    })),
  };
};

export function sortOutput(data) {
  data.forEach((el) => {
    let txtDates = el.dates;
    let txtDistances = el.distances;
    txtDates = txtDates.replace(/["[\]]/g, "");
    txtDistances = txtDistances.replace(/["[\]]/g, "");
    let datesTxtArray = txtDates.split(",");
    let distancesTxtArray = txtDistances.split(",");
    let dates = [];
    dates = datesTxtArray.map((dtTxt) => new Date(dtTxt));

    let length = dates.length;
    let swapped = false;
    do {
      swapped = false;
      for (let i = 0; i < length; i++) {
        if (dates[i] > dates[i + 1]) {
          let tmp = dates[i];
          dates[i] = dates[i + 1];
          dates[i + 1] = tmp;

          tmp = distancesTxtArray[i];
          distancesTxtArray[i] = distancesTxtArray[i + 1];
          distancesTxtArray[i + 1] = tmp;

          swapped = true;
        }
      }
    } while (swapped);
    dates = dates.map((el) => (isFinite(el) ? el.toISOString() : ""));
    distancesTxtArray = distancesTxtArray.map((el) =>
      Number.parseFloat(el).toFixed(2)
    );
    el.dates =
      '"' +
      JSON.stringify(dates).replace(/"/g, "'").replace(/.000Z/g, "") +
      '"';
    el.distances =
      '"' +
      JSON.stringify(distancesTxtArray).replace(/"/g, "'").replace(/'/g, "") +
      '"';
  });

  return data;
}
